import styled from '@emotion/styled';
import CloseIconSvg from '@/assets/icons/close.svg?react';

export const Backdrop = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => `${theme.colors.light}96`};
  z-index: 1000;
  inset: 0;
`;

export const Card = styled.div`
  position: relative;
  width: 100%;
  max-width: 320px;
  padding: 20px;
  border-radius: 16px;
  background: #fff;
`;

export const CloseButton = styled.button`
  display: flex;
  margin-left: auto;
  padding: 4px;
  line-height: 0;
  cursor: pointer;
  border: none;
  background: none;

  &:hover {
    opacity: 0.6;
  }
`;

export const CloseIcon = styled(CloseIconSvg)`
  width: 10px;
  height: 10px;

  path {
    stroke-width: 2px;
  }
`;

export const Heading = styled.h3`
  margin: 0;
  color: #000;
  line-height: 130%;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01rem;
`;

export const Text = styled.p`
  margin: 12px 0;
  color: #000;
  line-height: 130%;
  font-size: 14px;
  letter-spacing: 0.01rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EmailInput = styled.input<{ isInvalid: boolean }>`
  flex: 1;
  padding: 10px 20px;
  font-size: 16px;
  font-family: inherit;
  border: 1px solid ${({ isInvalid, theme }) => (isInvalid ? '#c0392b' : theme.colors.light)};
  border-radius: 20px;
  outline: none;

  &:focus {
    border-color: ${({ isInvalid, theme }) => (isInvalid ? '#c0392b' : theme.colors.light)};
  }
`;

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  color: #fff;
  cursor: pointer;
  border: none;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.light};

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }
`;
